import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from '../xposProvider/store'
import { ReportsFetchData } from './service/reportsService'
import { isLoggedIn } from '../../components/tsComponents/AuthGuard'
import { useNavigate } from 'react-router-dom'
import {
  fetchBillwiseReport,
  fetchBusinessSummaryCurrent,
  fetchCounterWiseReport,
  fetchDaywiseReport,
  fetchDuplicateBillReport,
  fetchPaymentwiseReport,
  fetchInventoryReport,
  fetchItemWiseReport,
  fetchOutletSummary,
  fetchUserwiseReport,
  fetchWriteOffReport,
  fetchDownloadReport,
  fetchOutletwiseSummaryForFranchise,
  fetchOutletwiseSummary,
  fetchOutletwiseSummaryForOutlet,
  fetchBillDetails,
  fetchWaiterItemWiseReport,
  fetchWaiterCommissionReport,
  fetchWaiterMonthWiseReport,
  fetchWaiterSalesReport
} from './reportsAction'
import { fetchBusinessSummary } from './reportsAction'

export function useFetchBusinessSumaryCurrentReport() {
  const dispatch: AppDispatch = useDispatch()
  const history = useNavigate()
  const businessSummaryCurrentReportLoading = useSelector(
    (state: RootState) => state['reports/fetchBusinessSummaryCurrent'].loading
  )
  const businessSummaryCurrentReportError = useSelector(
    (state: RootState) => state['reports/fetchBusinessSummaryCurrent'].error
  )
  const businessSummaryCurrentReportData = useSelector(
    (state: RootState) => state['reports/fetchBusinessSummaryCurrent'].data
  )

  const businessSummaryCurrentReportFetch = async (
    fetchPayload: ReportsFetchData | undefined
  ) => {
    let result = await isLoggedIn()
    if (!result) {
      history('/auth/sign-in')
      return
    }
    await dispatch(fetchBusinessSummaryCurrent(fetchPayload))
  }

  return {
    businessSummaryCurrentReportLoading,
    businessSummaryCurrentReportError,
    businessSummaryCurrentReportFetch,
    businessSummaryCurrentReportData
  }
}

export function useFetchBusinessSumaryReport() {
  const dispatch: AppDispatch = useDispatch()
  const history = useNavigate()
  const businessSummaryReportLoading = useSelector(
    (state: RootState) => state['reports/fetchBusinessSummary'].loading
  )
  const businessSummaryReportError = useSelector(
    (state: RootState) => state['reports/fetchBusinessSummary'].error
  )
  const businessSummaryReportData = useSelector(
    (state: RootState) => state['reports/fetchBusinessSummary'].data
  )

  const businessSummaryReportFetch = async (fetchPayload: ReportsFetchData) => {
    let result = await isLoggedIn()
    if (!result) {
      history('/auth/sign-in')
      return
    }
    await dispatch(fetchBusinessSummary(fetchPayload))
  }

  return {
    businessSummaryReportLoading,
    businessSummaryReportError,
    businessSummaryReportFetch,
    businessSummaryReportData
  }
}

export function useFetchOutletSummary() {
  const dispatch: AppDispatch = useDispatch()
  const history = useNavigate()
  const outletSummaryLoading = useSelector(
    (state: RootState) => state['reports/fetchOutletSummary'].loading
  )
  const outletSummaryError = useSelector(
    (state: RootState) => state['reports/fetchOutletSummary'].error
  )
  const outletSummaryData = useSelector(
    (state: RootState) => state['reports/fetchOutletSummary'].data
  )

  const outletSummaryFetch = async (fetchPayload: ReportsFetchData) => {
    let result = await isLoggedIn()
    if (!result) {
      history('/auth/sign-in')
      return
    }
    await dispatch(fetchOutletSummary(fetchPayload))
  }

  return {
    outletSummaryLoading,
    outletSummaryError,
    outletSummaryFetch,
    outletSummaryData
  }
}

export function useFetchOutletwiseSummary() {
  const dispatch: AppDispatch = useDispatch()
  const history = useNavigate()
  const loading = useSelector(
    (state: RootState) => state['reports/fetchOutletwiseSummary'].loading
  )
  const error = useSelector(
    (state: RootState) => state['reports/fetchOutletwiseSummary'].error
  )
  const data = useSelector(
    (state: RootState) => state['reports/fetchOutletwiseSummary'].data
  )

  const fetch = async (fetchPayload: ReportsFetchData) => {
    let result = await isLoggedIn()
    if (!result) {
      history('/auth/sign-in')
      return
    }
    await dispatch(fetchOutletwiseSummary(fetchPayload))
  }

  return {
    loading,
    error,
    fetch,
    data
  }
}

export function useFetchOutletSummaryForFranchise() {
  const dispatch: AppDispatch = useDispatch()
  const history = useNavigate()
  const loading = useSelector(
    (state: RootState) =>
      state['reports/fetchOutletSummaryForFranchise'].loading
  )
  const error = useSelector(
    (state: RootState) => state['reports/fetchOutletSummaryForFranchise'].error
  )
  const data = useSelector(
    (state: RootState) => state['reports/fetchOutletSummaryForFranchise'].data
  )

  const fetch = async (fetchPayload: ReportsFetchData) => {
    let result = await isLoggedIn()
    if (!result) {
      history('/auth/sign-in')
      return
    }
    await dispatch(fetchOutletwiseSummaryForFranchise(fetchPayload))
  }

  return { loading, error, fetch, data }
}

export function useFetchOutletSummaryForOutlet() {
  const dispatch: AppDispatch = useDispatch()
  const history = useNavigate()
  const loading = useSelector(
    (state: RootState) => state['reports/fetchOutletSummaryForOutlet'].loading
  )
  const error = useSelector(
    (state: RootState) => state['reports/fetchOutletSummaryForOutlet'].error
  )
  const data = useSelector(
    (state: RootState) => state['reports/fetchOutletSummaryForOutlet'].data
  )

  const fetch = async (fetchPayload: ReportsFetchData) => {
    let result = await isLoggedIn()
    if (!result) {
      history('/auth/sign-in')
      return
    }
    await dispatch(fetchOutletwiseSummaryForOutlet(fetchPayload))
  }

  return { loading, error, fetch, data }
}

export function useFetchBillwiseReport() {
  const dispatch: AppDispatch = useDispatch()
  const history = useNavigate()
  const billwiseReportLoading = useSelector(
    (state: RootState) => state['reports/fetchBillwiseReport'].loading
  )
  const billwiseReportError = useSelector(
    (state: RootState) => state['reports/fetchBillwiseReport'].error
  )
  const billwiseReportData = useSelector(
    (state: RootState) => state['reports/fetchBillwiseReport'].data
  )

  const billwiseReportFetch = async (fetchPayload: ReportsFetchData) => {
    let result = await isLoggedIn()
    if (!result) {
      history('/auth/sign-in')
      return
    }
    await dispatch(fetchBillwiseReport(fetchPayload))
  }

  return {
    billwiseReportLoading,
    billwiseReportError,
    billwiseReportFetch,
    billwiseReportData
  }
}

export function useFetchDaywiseReport() {
  const dispatch: AppDispatch = useDispatch()
  const history = useNavigate()
  const daywiseReportLoading = useSelector(
    (state: RootState) => state['reports/fetchDaywiseReport'].loading
  )
  const daywiseReportError = useSelector(
    (state: RootState) => state['reports/fetchDaywiseReport'].error
  )
  const daywiseReportData = useSelector(
    (state: RootState) => state['reports/fetchDaywiseReport'].data
  )

  const daywiseReportFetch = async (fetchPayload: ReportsFetchData) => {
    let result = await isLoggedIn()
    if (!result) {
      history('/auth/sign-in')
      return
    }
    await dispatch(fetchDaywiseReport(fetchPayload))
  }

  return {
    daywiseReportLoading,
    daywiseReportError,
    daywiseReportFetch,
    daywiseReportData
  }
}

export function useFetchItemwiseReport() {
  const dispatch: AppDispatch = useDispatch()
  const history = useNavigate()
  const itemwiseReportLoading = useSelector(
    (state: RootState) => state['reports/fetchItemWiseReport'].loading
  )
  const itemwiseReportError = useSelector(
    (state: RootState) => state['reports/fetchItemWiseReport'].error
  )
  const itemwiseReportData = useSelector(
    (state: RootState) => state['reports/fetchItemWiseReport'].data
  )

  const itemwiseReportFetch = async (fetchPayload: ReportsFetchData) => {
    let result = await isLoggedIn()
    if (!result) {
      history('/auth/sign-in')
      return
    }
    await dispatch(fetchItemWiseReport(fetchPayload))
  }

  return {
    itemwiseReportLoading,
    itemwiseReportError,
    itemwiseReportFetch,
    itemwiseReportData
  }
}

export function useFetchInventoryReport() {
  const dispatch: AppDispatch = useDispatch()
  const history = useNavigate()
  const inventoryReportLoading = useSelector(
    (state: RootState) => state['reports/fetchInventoryReport'].loading
  )
  const inventoryReportError = useSelector(
    (state: RootState) => state['reports/fetchInventoryReport'].error
  )
  const inventoryReportData = useSelector(
    (state: RootState) => state['reports/fetchInventoryReport'].data
  )

  const inventoryReportFetch = async (fetchPayload: ReportsFetchData) => {
    let result = await isLoggedIn()
    if (!result) {
      history('/auth/sign-in')
      return
    }
    await dispatch(fetchInventoryReport(fetchPayload))
  }

  return {
    inventoryReportLoading,
    inventoryReportError,
    inventoryReportFetch,
    inventoryReportData
  }
}

export function useFetchUserWiseReport() {
  const dispatch: AppDispatch = useDispatch()
  const history = useNavigate()
  const userwiseReportLoading = useSelector(
    (state: RootState) => state['reports/fetchUserwiseReport'].loading
  )
  const userwiseReportError = useSelector(
    (state: RootState) => state['reports/fetchUserwiseReport'].error
  )
  const userwiseReportData = useSelector(
    (state: RootState) => state['reports/fetchUserwiseReport'].data
  )

  const userwiseReportFetch = async (fetchPayload: ReportsFetchData) => {
    let result = await isLoggedIn()
    if (!result) {
      history('/auth/sign-in')
      return
    }
    await dispatch(fetchUserwiseReport(fetchPayload))
  }

  return {
    userwiseReportLoading,
    userwiseReportError,
    userwiseReportFetch,
    userwiseReportData
  }
}

export function useFetchCounterWiseReport() {
  const dispatch: AppDispatch = useDispatch()
  const history = useNavigate()
  const counterwiseReportLoading = useSelector(
    (state: RootState) => state['reports/fetchCounterWiseReport'].loading
  )
  const counterwiseReportError = useSelector(
    (state: RootState) => state['reports/fetchCounterWiseReport'].error
  )
  const counterwiseReportData = useSelector(
    (state: RootState) => state['reports/fetchCounterWiseReport'].data
  )

  const counterwiseReportFetch = async (fetchPayload: ReportsFetchData) => {
    let result = await isLoggedIn()
    if (!result) {
      history('/auth/sign-in')
      return
    }
    await dispatch(fetchCounterWiseReport(fetchPayload))
  }

  return {
    counterwiseReportLoading,
    counterwiseReportError,
    counterwiseReportFetch,
    counterwiseReportData
  }
}

export function useFetchWriteOffReport() {
  const dispatch: AppDispatch = useDispatch()
  const history = useNavigate()
  const writeoffReportLoading = useSelector(
    (state: RootState) => state['reports/fetchWriteOffReport'].loading
  )
  const writeoffReportError = useSelector(
    (state: RootState) => state['reports/fetchWriteOffReport'].error
  )
  const writeoffReportData = useSelector(
    (state: RootState) => state['reports/fetchWriteOffReport'].data
  )

  const writeoffReportFetch = async (fetchPayload: ReportsFetchData) => {
    let result = await isLoggedIn()
    if (!result) {
      history('/auth/sign-in')
      return
    }
    await dispatch(fetchWriteOffReport(fetchPayload))
  }

  return {
    writeoffReportLoading,
    writeoffReportError,
    writeoffReportFetch,
    writeoffReportData
  }
}

export function useFetchDuplicateBillReport() {
  const dispatch: AppDispatch = useDispatch()
  const history = useNavigate()
  const duplicateBillReportLoading = useSelector(
    (state: RootState) => state['reports/fetchDuplicateBillReport'].loading
  )
  const duplicateBillReportError = useSelector(
    (state: RootState) => state['reports/fetchDuplicateBillReport'].error
  )
  const duplicateBillReportData = useSelector(
    (state: RootState) => state['reports/fetchDuplicateBillReport'].data
  )

  const duplicateBillReportFetch = async (fetchPayload: ReportsFetchData) => {
    let result = await isLoggedIn()
    if (!result) {
      history('/auth/sign-in')
      return
    }
    await dispatch(fetchDuplicateBillReport(fetchPayload))
  }

  return {
    duplicateBillReportLoading,
    duplicateBillReportError,
    duplicateBillReportFetch,
    duplicateBillReportData
  }
}

export function useFetchPaymentwiseReport() {
  const dispatch: AppDispatch = useDispatch()
  const history = useNavigate()
  const paymentwiseReportLoading = useSelector(
    (state: RootState) => state['reports/fetchPaymentwiseReport'].loading
  )
  const paymentwiseReportError = useSelector(
    (state: RootState) => state['reports/fetchPaymentwiseReport'].error
  )
  const paymentwiseReportData = useSelector(
    (state: RootState) => state['reports/fetchPaymentwiseReport'].data
  )

  const paymentwiseReportFetch = async (fetchPayload: ReportsFetchData) => {
    let result = await isLoggedIn()
    if (!result) {
      history('/auth/sign-in')
      return
    }
    await dispatch(fetchPaymentwiseReport(fetchPayload))
  }

  return {
    paymentwiseReportLoading,
    paymentwiseReportError,
    paymentwiseReportFetch,
    paymentwiseReportData
  }
}

export function useDownloadReports() {
  const dispatch: AppDispatch = useDispatch()
  const history = useNavigate()
  const downloadReportsLoading = useSelector(
    (state: RootState) => state['reports/fetchDownloadReport'].loading
  )
  const downloadReportsError = useSelector(
    (state: RootState) => state['reports/fetchDownloadReport'].error
  )
  const downloadReportsData = useSelector(
    (state: RootState) => state['reports/fetchDownloadReport'].data
  )

  const downloadReportsFetch = async (fetchPayload: ReportsFetchData) => {
    let result = await isLoggedIn()
    if (!result) {
      history('/auth/sign-in')
      return
    }
    const res = await dispatch(fetchDownloadReport(fetchPayload))
    return res
  }
  return {
    downloadReportsLoading,
    downloadReportsError,
    downloadReportsFetch,
    downloadReportsData
  }
}

export function useFetchBillDetails() {
  const dispatch: AppDispatch = useDispatch()
  const history = useNavigate()
  
  const billDetailsLoading = useSelector(
    (state: RootState) => state['reports/fetchBillDetails'].loading
  )
  const billDetailsError = useSelector(
    (state: RootState) => state['reports/fetchBillDetails'].error
  )
  const billDetailsData = useSelector(
    (state: RootState) => state['reports/fetchBillDetails'].data
  )

  const billDetailsFetch = async (billId: string) => {
    let result = await isLoggedIn()
    if (!result) {
      history('/auth/sign-in')
      return
    }
    const res = await dispatch(fetchBillDetails(billId))
    return res
  }
  
  return {
    billDetailsLoading,
    billDetailsError,
    billDetailsFetch,
    billDetailsData
  }
}

export function useFetchWaiterItemWiseReport() {
  const dispatch: AppDispatch = useDispatch()
  const history = useNavigate()
  const waiterItemWiseReportLoading = useSelector(
    (state: RootState) => state['reports/fetchWaiterItemWiseReport'].loading
  )
  const waiterItemWiseReportError = useSelector(
    (state: RootState) => state['reports/fetchWaiterItemWiseReport'].error
  )
  const waiterItemWiseReportData = useSelector(
    (state: RootState) => state['reports/fetchWaiterItemWiseReport'].data
  )

  const waiterItemWiseReportFetch = async (fetchPayload: ReportsFetchData) => {
    let result = await isLoggedIn()
    if (!result) {
      history('/auth/sign-in')
      return
    }
    await dispatch(fetchWaiterItemWiseReport(fetchPayload))
  }

  return {
    waiterItemWiseReportLoading,
    waiterItemWiseReportData,
    waiterItemWiseReportError,
    waiterItemWiseReportFetch
  }
}

export function useFetchWaiterCommissionReport() {
  const dispatch: AppDispatch = useDispatch()
  const history = useNavigate()
  const waiterCommissionReportLoading = useSelector(
    (state: RootState) => state['reports/fetchWaiterCommissionReport'].loading
  )
  const waiterCommissionReportError = useSelector(
    (state: RootState) => state['reports/fetchWaiterCommissionReport'].error
  )
  const waiterCommissionReportData = useSelector(
    (state: RootState) => state['reports/fetchWaiterCommissionReport'].data
  )

  const waiterCommissionReportFetch = async (fetchPayload: ReportsFetchData) => {
    let result = await isLoggedIn()
    if (!result) {
      history('/auth/sign-in')
      return
    }
    await dispatch(fetchWaiterCommissionReport(fetchPayload))
  }

  return {
    waiterCommissionReportLoading,
    waiterCommissionReportData,
    waiterCommissionReportError,
    waiterCommissionReportFetch
  }
}

export function useFetchWaiterMonthWiseReport() {
  const dispatch: AppDispatch = useDispatch()
  const history = useNavigate()
  const waiterMonthWiseReportLoading = useSelector(
    (state: RootState) => state['reports/fetchWaiterMonthWiseReport'].loading
  )
  const waiterMonthWiseReportError = useSelector(
    (state: RootState) => state['reports/fetchWaiterMonthWiseReport'].error
  )
  const waiterMonthWiseReportData = useSelector(
    (state: RootState) => state['reports/fetchWaiterMonthWiseReport'].data
  )

  const waiterMonthWiseReportFetch = async (fetchPayload: ReportsFetchData) => {
    let result = await isLoggedIn()
    if (!result) {
      history('/auth/sign-in')
      return
    }
    await dispatch(fetchWaiterMonthWiseReport(fetchPayload))
  }

  return {
    waiterMonthWiseReportLoading,
    waiterMonthWiseReportData,
    waiterMonthWiseReportError,
    waiterMonthWiseReportFetch
  }
}

export function useFetchWaiterSalesReport() {
  const dispatch: AppDispatch = useDispatch()
  const history = useNavigate()
  const waiterSalesReportLoading = useSelector(
    (state: RootState) => state['reports/fetchWaiterSalesReport'].loading
  )
  const waiterSalesReportError = useSelector(
    (state: RootState) => state['reports/fetchWaiterSalesReport'].error
  )
  const waiterSalesReportData = useSelector(
    (state: RootState) => state['reports/fetchWaiterSalesReport'].data
  )

  const waiterSalesReportFetch = async (fetchPayload: ReportsFetchData) => {
    let result = await isLoggedIn()
    if (!result) {
      history('/auth/sign-in')
      return
    }
    await dispatch(fetchWaiterSalesReport(fetchPayload))
  }

  return {
    waiterSalesReportLoading,
    waiterSalesReportData,
    waiterSalesReportError,
    waiterSalesReportFetch
  }
}
